
import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as PagesRoute from "./pages";
import * as KeysRoute from "./keys";
import * as AccountRoute from "./account";

// Pages is the only section you work in, so the root lands there.
const RootRoute = () => <Redirect to={`/page`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"Repoflow Pages"} menu={[]} />

            <Sidebar
              menu={[
                {
                  icon: "file-text-o",
                  label: "Pages",
                  to: `/page`,
                },
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                }/*,
            {
              icon: "cogs",
              label: "Configuration",
              to: `/config`,
            },*/
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route path={`/account`} component={AccountRoute.Indice} />
                  <Route path={`/page`} component={PagesRoute.Indice} />
                  <Route path={`/key`} component={KeysRoute.Indice} />
                </Switch>
              </ol>

              <Switch>
                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/page`} component={PagesRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
